module.exports = __webpack_public_path__ + "static/media/(H)_MG_5721-bijuterias.b30b4f27.jpg";